import apiClient from './apiClient'


const getCountries = (tenant) => {
  return apiClient.get(`/${tenant}/Country`)
}


export default {
  getCountries
}
